module.exports = __webpack_public_path__ + "img/7.3211e0b6.png";